import { FloorContainer } from '../../containers/advancedFilters/FloorContainer';
import { IFilter } from '../../types/filters';

export const floor: IFilter = {
  component: FloorContainer,
};
